// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_2KWOR","button":"view-header_button_qK_BZ","active":"view-header_active_3ggeF","btnExport":"view-header_btnExport_Vm3yv","mr":"view-header_mr_24NAA"};